export default function CStudyPlan() {
  return <h2>C Study Plan</h2>;
}
